import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { ExternalService } from 'src/app/services/external.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-mas-garantia-header',
  templateUrl: './mas-garantia-header.component.html',
  styleUrls: ['./mas-garantia-header.component.scss']
})
export class MasGarantiaHeaderComponent implements OnInit {

  isMobile:boolean = false;
  faAngleDown = faAngleDown
  
  constructor(
    public commonService:CommonService,
    private fb: FormBuilder,
    private externalServcie:ExternalService,
    public storageService:StorageService,
    public translate: TranslateService,
    private breakPointObserver: BreakpointObserver
  ) { 
  }

  ngOnInit(): void {
    this.breakPoint();
  }

  breakPoint(){
    this.breakPointObserver.observe(['(max-width: 768px)']).subscribe( result => {
      if(result.matches){
        this.isMobile = true;
      }else{ 
        this.isMobile = false;
      }
    });
  }

  logOut(){
    var auth = this.storageService.getData('auth')
    var sessionId = this.storageService.getData('sessionId')
    this.externalServcie.logOut()
  }

  formGroup: FormGroup = this.fb.group({
    languaje: [this.translate.currentLang,Validators.required]
  })
}
